<template>
    <button class="cw-button-hollow cw-button-hollow-secondary" @click="handleClick">
        <slot></slot>
    </button>
</template>

<script setup>
import {useChooserStore} from "../../stores/ChooserStore";
import VARS from "../../config_chooser_choice_vars";
import {storeToRefs} from "pinia";

const props = defineProps({
    productLineId: Number
})

const chooserStore = useChooserStore();

const {
    selectedStructures,
    selectedProductLine,
    selectedSearchMode,
    requestInitiatedFromPlayhouseButton
} = storeToRefs(chooserStore);

async function handleClick() {
    await chooserStore.$reset()

    selectedProductLine.value = props.productLineId
    selectedSearchMode.value = 'advanced'
    selectedStructures.value = [VARS.STRUCTURES_PH.id]
    requestInitiatedFromPlayhouseButton.value = true

    window.location.href = "/chooser";
}
</script>
